import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ICellRendererAngularComp } from "@bfx/ag-grid-angular";
import { ICellRendererParams, RowNode } from "ag-grid-community";
import { Observer } from "rxjs";

interface CellParams extends ICellRendererParams {
  toggleLocked: Observer<RowNode>;
}
@Component({
  selector: "fr-order-status-renderer",
  template: `<span class="badge-icon bfx-badge-info-bold" *ngIf="forwardFirstOrder">FF</span>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrderStatusRenderer implements ICellRendererAngularComp {
  public forwardFirstOrder: boolean = false;
  previous: { forwardFirstOrder: boolean };

  constructor(public cd: ChangeDetectorRef) {
    this.previous = { forwardFirstOrder: this.forwardFirstOrder };
  }

  agInit(params: CellParams): void {
    this.updateParams(params);
  }

  private updateParams(params: CellParams) {
    this.previous.forwardFirstOrder = this.forwardFirstOrder;
    this.forwardFirstOrder = params.data?.forwardFirstOrder === true;
    return this.forwardFirstOrder !== this.previous.forwardFirstOrder;
  }

  refresh(params?: CellParams): boolean {
    if (this.updateParams(params)) {
      this.cd.markForCheck();
    }

    return true;
  }
}
